import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { ProtectedRoute } from './ProtectedRoute';
import { RoleProtectedRoute } from './RoleProtectedRoute';
import { Layout } from '@/layouts/Layout';
import { ROUTES } from '@/config/constants';
import { LoadingFallback } from '@/components/Common/LoadingFallback';

// 懒加载页面组件
const Login = lazy(() => import('@/pages/Login'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const TenantList = lazy(() => import('@/pages/Tenant'));
const OperatorList = lazy(() => import('@/pages/Operator'));
const AuditLogs = lazy(() => import('@/pages/Audit'));
const CategoryList = lazy(() => import('@/pages/Category'));
const AlertConfig = lazy(() => import('@/pages/Monitor/AlertConfig'));
const AlertLogs = lazy(() => import('@/pages/Monitor/AlertLogs'));
const ServerHealth = lazy(() => import('@/pages/Monitor/ServerHealth'));
const MetaMonitor = lazy(() => import('@/pages/Monitor/MetaMonitor'));

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <Login />
      </Suspense>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: 'dashboard',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: 'tenants',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <TenantList />
          </Suspense>
        ),
      },
      {
        path: 'operators',
        element: (
          <RoleProtectedRoute requiredRole="super_admin">
            <Suspense fallback={<LoadingFallback />}>
              <OperatorList />
            </Suspense>
          </RoleProtectedRoute>
        ),
      },
      {
        path: 'audit',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <AuditLogs />
          </Suspense>
        ),
      },
      {
        path: 'categories',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <CategoryList />
          </Suspense>
        ),
      },
      {
        path: 'monitor/health',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <ServerHealth />
          </Suspense>
        ),
      },
      {
        path: 'monitor/alert-configs',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <AlertConfig />
          </Suspense>
        ),
      },
      {
        path: 'monitor/alert-logs',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <AlertLogs />
          </Suspense>
        ),
      },
      {
        path: 'monitor/meta-monitor',
        element: (
          <Suspense fallback={<LoadingFallback />}>
            <MetaMonitor />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);